import React, {
	useRef, useContext,
} from 'react';
import Loadable from '@loadable/component';

// Atoms
import {
	FullScreenWrapper, FullScreenContentWrapper,
} from '../../components/Atoms/Wrappers';

// Components
import MetaDescription from '../../components/Molecules/MetaDescription';

// Layouts
import SectionWrapper from '../../Layouts/SectionWrapper';
import { FullScreenContext } from '../../components/Context/FullScreenContext';
import MetaImage from '../../assets/images/meta/play-with-a-friend-meta.jpg';

const ConnectionProvider = Loadable(() => import('../../components/modules/Yamb/components/ConnectionProvider'), {
	fallback: <div>Loading</div>,
});

function PlayWithAFriend() {
	const fullScreenWrapper = useRef(null);
	const { fullScreen, onClickFullScreen } = useContext(FullScreenContext);
	const handleFullScreenClick = () => {
		onClickFullScreen(fullScreenWrapper.current);
	};
	return (
		<>
			<MetaDescription
				page={{
					meta: {
						pageTitle: 'Yamb Online - Play with a friend',
						metaDescription: 'Online multiplayer Yamb, Yahtzee like game',
						ogImage: {
							src: MetaImage,
							height: 630,
							width: 1200,
						},
					},
				}}

			/>
			<SectionWrapper
				background
			>
				<FullScreenWrapper ref={fullScreenWrapper} isFullScreen={fullScreen}>
					<FullScreenContentWrapper>
						<ConnectionProvider handleFullScreenClick={handleFullScreenClick} />
					</FullScreenContentWrapper>
				</FullScreenWrapper>
			</SectionWrapper>
		</>
	);
}

export default PlayWithAFriend;
